exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".clock[data-v-d3b63f62] {\n  text-align: center;\n  margin-bottom: 1.5rem;\n}\n.clock-time[data-v-d3b63f62] {\n  font-size: 3rem;\n  font-weight: bold;\n  position: relative;\n}\n@media (min-width: 500px) {\n.clock-time[data-v-d3b63f62] {\n    font-size: 6rem;\n}\n}\n.clock-colon[data-v-d3b63f62] {\n  display: inline-block;\n  transform: translateY(-0.5rem);\n}\n.clock-meridiem[data-v-d3b63f62] {\n  font-size: 0.75em;\n}\n.clock-timer[data-v-d3b63f62] {\n  position: absolute;\n  right: -0.5em;\n  bottom: 0.3em;\n}\n@media (min-width: 500px) {\n.clock-timer[data-v-d3b63f62] {\n    right: -0.3em;\n}\n}", ""]);

// exports
